import React from 'react';
import { Text, View } from 'react-native';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';

const PushNotificationsContent: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      No more refreshing the app to see if your match result was updated or if someone
      challenged you. Tournaly now sends real-time push notifications so you're always
      in the loop — without having to check the app constantly.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      What triggers a notification?
    </Text>
    {[
      'Tournament started — your bracket is ready to play',
      'Tournament invitation received — someone wants you in their tournament',
      'Friend request — a player wants to connect',
      'Challenge received — someone challenged you to a 1v1',
      'Match result updated — see how you did',
      'Tournament completed — final standings are in',
      'League invitation — join a league season',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      Full control over what you receive
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      You can toggle each notification type individually from Settings. Only want to know
      about match results but not friend requests? No problem — every category has its own switch.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      In-app notification centre
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      Everything is also saved in the in-app notification centre — the bell icon in the
      navigation drawer. Unread notifications show a badge count so nothing gets lost
      even if you miss a push.
    </Text>
  </View>
);

const PushNotificationsContentEs: React.FC<{ colors: ThemeColors }> = ({ colors }) => (
  <View>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Se acabó refrescar la app para ver si tu resultado fue actualizado o si alguien te
      desafió. Tournaly ahora envía notificaciones push en tiempo real para que siempre
      estés al tanto — sin tener que entrar constantemente a la app.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      ¿Qué activa una notificación?
    </Text>
    {[
      'Torneo iniciado — tu bracket está listo para jugar',
      'Invitación a torneo recibida — alguien te quiere en su torneo',
      'Solicitud de amistad — un jugador quiere conectar contigo',
      'Desafío recibido — alguien te reta a un 1v1',
      'Resultado de partido actualizado — ve cómo te fue',
      'Torneo completado — la clasificación final está lista',
      'Invitación a liga — únete a una temporada de liga',
    ].map((item, index) => (
      <View key={index} style={{ flexDirection: 'row', marginBottom: 10, alignItems: 'flex-start' }}>
        <Text style={{ color: colors.primary, marginRight: 10, fontSize: 16 }}>•</Text>
        <Text style={{ fontSize: 15, lineHeight: 23, color: colors.textSecondary, flex: 1 }}>{item}</Text>
      </View>
    ))}

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 24 }}>
      Control total sobre lo que recibes
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.text, marginBottom: 20 }}>
      Puedes activar o desactivar cada tipo de notificación de forma individual desde Ajustes.
      ¿Solo quieres saber sobre resultados de partidos pero no sobre solicitudes de amistad?
      Sin problema — cada categoría tiene su propio interruptor.
    </Text>

    <Text style={{ fontSize: 20, fontWeight: '700', color: colors.text, marginBottom: 12, marginTop: 8 }}>
      Centro de notificaciones en la app
    </Text>
    <Text style={{ fontSize: 16, lineHeight: 26, color: colors.textSecondary }}>
      Todo queda guardado también en el centro de notificaciones de la app — el icono de
      campana en el menú de navegación. Las notificaciones no leídas muestran un contador
      para que nada se pierda aunque te hayas perdido el push.
    </Text>
  </View>
);

export const post: BlogPost = {
  slug: '2026-02-10-push-notifications',
  title: 'Real-Time Push Notifications Are Here',
  titleEs: 'Las Notificaciones Push en Tiempo Real Ya Están Aquí',
  date: '2026-02-10',
  summary: 'Real-time push notifications for tournament organizers and players — get match results, bracket updates, invitations, and challenges delivered the moment they happen.',
  summaryEs: 'Notificaciones push en tiempo real para organizadores y jugadores de torneos — recibe resultados de partidos, actualizaciones de bracket, invitaciones y desafíos al instante.',
  tags: ['Notifications', 'Feature'],
  Content: PushNotificationsContent,
  ContentEs: PushNotificationsContentEs,
};
